<!-- @Version: 1.0.4 --> 
@if (done$$()  == true) {
   <form [formGroup]="fgCheckbox" data-testid="checkboxcontainer">
      <div  class="check-row" [ngClass]="(fieldItem.attribute_4 && fieldItem.attribute_4 == DIRECTION.VERTICAL) ? DIRECTION.VERTICAL : DIRECTION.HORIZONTAL" data-testid="checkboxgroup">
         @for (checkbox of sFieldItemCheckbox.values; track checkbox.value; let idx = $index) {
            <mat-checkbox [color]="TRANSLATE_PATH.COLOR_CHECKBOX | translateDesign"   class="flex-item" [attr.data-testid]="'mat-checkbox' + idx" [formControlName]="idx">{{checkbox.label}}</mat-checkbox>
         }
      </div>
      <div class="error-messages">
         @if (fgCheckbox.errors && fgCheckbox.dirty && fgCheckbox.errors.required && !fgCheckbox.errors.valid) {
            <mat-error [attr.data-testid]="'error-required'">{{this.sFieldItemCheckbox.errorCodes.errorCodeRequired}}</mat-error>
         }
         @if (fgCheckbox.errors && fgCheckbox.dirty && fgCheckbox.errors.valid) {
            <mat-error [attr.data-testid]="'error-valid'">{{this.sFieldItemCheckbox.errorCodes.errorCodeValid}}</mat-error>
         }
         @if (fieldItem.required && !fgCheckbox.disabled && !(fgCheckbox.errors && fgCheckbox.dirty && fgCheckbox.errors.required && !fgCheckbox.errors.valid)) {
            <mat-hint data-testid="hint-required">{{TRANSLATE_PATH.REQUIRED | translateDesign}}</mat-hint>
         }
         @if (!(fgCheckbox.errors && fgCheckbox.dirty && fgCheckbox.errors.required && !fgCheckbox.errors.valid) && !(fgCheckbox.errors && fgCheckbox.dirty && fgCheckbox.errors.valid) && !(fieldItem.required && !fgCheckbox.disabled && !(fgCheckbox.errors && fgCheckbox.dirty && fgCheckbox.errors.required && !fgCheckbox.errors.valid))) {
            <mat-hint> </mat-hint>
         }
      </div>
   </form>
}
